import type AdvancedSearchViewState from './AdvancedSearchViewState';
import type { ObservableMap } from 'mobx';
import type { OwaDate } from 'owa-datetime';
import type { FolderForestNode } from 'owa-favorites-types';
import type { SearchScope, SuggestionSet, SearchProvider } from 'owa-search-service';
import type { FiltersInstrumentationContext } from './FiltersInstrumentationContext';
import { SearchFile } from 'owa-search-service/lib/data/schema/SubstrateSearchResponse';
import { AnswerPositionAndPropertyMapping } from './AnswerPositionAndPropertyMapping';

export default interface MailSearchStore {
    toDate: OwaDate; // Advanced Search/filter value
    fromDate: OwaDate; // Advanced Search/filter value
    includeAttachments: boolean; // Advanced Search/filter value
    initialSearchScope: SearchScope; // Initial search scope session begins in
    isSearchHistoryDirty: boolean; // Flag indicating whether the search history is dirty, and used to determine if we should update search history in user config
    isAnswerInitialized: boolean; // Flag to decide that Shared Answer should be rendered or not
    isAnswerLocalizationCompleted: boolean; // Flag to decide if answer strings have to be fetched before initializing answers
    isUnread: boolean; // Flag to indicate returning only unread items in search
    isToMe: boolean; // Flag to indicate returning only items where the user is on the To or Cc line
    isFlagged: boolean; // Flag to indicate returning only items where the message is flagged
    isMentioned: boolean; // Flag to indicate returning only items where the user is mentioned
    previousNode: FolderForestNode; // The node selected before user entered into search
    searchNumber: number;
    staticSearchScope: SearchScope; // The current search scope
    staticSearchScopeList: SearchScope[]; // Prebuilt list of search scopes available for the current scenario
    shouldShowAdvancedSearch: boolean; // Indicates if Advanced Search callout is visible
    advancedSearchViewState: AdvancedSearchViewState; // View state of the advanced search UI
    initialAdvancedSearchViewState: AdvancedSearchViewState; // Initial view state of the advanced search UI
    legacySuggestions: ObservableMap<string, SuggestionSet>; // Legacy (non-QF) suggestion set cache
    recipientForPersonalizedGhostTextIndex: number; // Indicates what recipient should be displayed in the ghost text
    generalizedGhostTextBankIndex: number; // Indicates the index of a string in the General Ghost Text Bank
    personalizedGhostTextBankIndex: number; // Indicates the index of a string in the Personalized Ghost Text Bank
    usePersonalGhostText: boolean; // Flag indicating whether to use general or personal ghost text
    isAnswerAvailable: boolean;
    provider: SearchProvider;
    isAlterationRecourse: boolean;
    filtersInstrumentationContext: FiltersInstrumentationContext;
    answersPositionAndPropertyMapping: ObservableMap<number, AnswerPositionAndPropertyMapping[]>;
    activeSearchTab?: SearchTab;
    fileSearchResults: SearchFile[];
}

export enum SearchTab {
    Mail = 'Mail',
    Files = 'Files',
}
